import type { CloudAPI } from '@yandex-360/telemost-sdk/cloud-api';

import { convertRecipient } from '../../../helpers/convert-recipient';
import { Artifact, RecipientFetchingStatus } from '../../fetching/types';

export const convertArtifact = ({
    id,
    started_at,
    stopped_at,
    am_i_recipient,
    link,
    recipients,
    recipients_total,
    status,
    error,
}: CloudAPI.ConferenceArtifacts.Artifact): Artifact => ({
    id,
    startedAt: started_at,
    stoppedAt: stopped_at,
    amIRecipient: am_i_recipient,
    link,
    recipientFetchingStatus: RecipientFetchingStatus.NOT_FETCHED,
    recipients: recipients?.map(convertRecipient) || [],
    recipientsTotal: recipients_total,
    status,
    error,
});
